import type { TFunction } from 'i18next';
import type {
  PurchaseOrderActivityDetailState,
  PurchaseOrderActivityItem,
  PurchaseOrderActivityLineChange,
} from '../types/purchase-order-activity-item';

type PurchaseOrderActivityLineUpdatedProps = {
  activity: PurchaseOrderActivityItem;
  onOpenDetail: (detail: PurchaseOrderActivityDetailState) => void;
  t: TFunction<'purchaseOrder'>;
};

export function PurchaseOrderActivityLineUpdated({
  activity,
  onOpenDetail,
  t,
}: PurchaseOrderActivityLineUpdatedProps) {
  const rows = activity.metadata?.values ?? [];
  const count = activity.metadata?.changedLinesCount;

  return (
    <>
      <span className='font-semibold'>{t('activity.line.updated')}</span>
      <button
        className='cursor-pointer font-medium text-foreground underline underline-offset-2'
        onClick={() =>
          onOpenDetail({
            kind: 'changes',
            title: t('activity.titles.updated'),
            description: t('activity.descriptions.updatedProducts', { count }),
            rows: rows as PurchaseOrderActivityLineChange[],
          })
        }
        type='button'
      >
        {t('activity.actions.viewUpdated')}
      </button>
    </>
  );
}
